import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import React from "react";

import { AnalysisProfile } from "../../types";

interface EntityFilterBarProps {
  searchTerm: string;
  selectedGroup: string;
  selectedStatus: string;
  profiles: AnalysisProfile[];
  onSearchChange: (value: string) => void;
  onGroupChange: (value: string) => void;
  onStatusChange: (value: string) => void;
}

export const EntityFilterBar: React.FC<EntityFilterBarProps> = ({
  searchTerm,
  selectedGroup,
  selectedStatus,
  profiles,
  onSearchChange,
  onGroupChange,
  onStatusChange
}) => {
  return (
    <Box display="flex" gap={2} alignItems="center">
      <TextField
        placeholder="Search people..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        size="small"
        sx={{ minWidth: 250 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          )
        }}
      />

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>All Groups</InputLabel>
        <Select
          value={selectedGroup}
          onChange={(e) => onGroupChange(e.target.value)}
          label="All Groups"
        >
          <MenuItem value="">All Groups</MenuItem>
          <MenuItem value="unassigned">Unassigned</MenuItem>
          {profiles.map((profile) => (
            <MenuItem key={profile.id} value={profile.id}>
              {profile.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel>All Status</InputLabel>
        <Select
          value={selectedStatus}
          onChange={(e) => onStatusChange(e.target.value)}
          label="All Status"
        >
          <MenuItem value="">All Status</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="disabled">Disabled</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};
